import * as React from "react";
import { useState, useEffect } from "react";
// import cargandoCard from "../../components/cargando-card";
import Modulo from "../../components/modulo";
import { MODULOS_ADMINISTRACION } from "./modulos-administracion";
import { obtenerInfoUsuario } from "../../api/api-usuario-web";
import { INT_TIPO_USUARIO } from "../../utils/const/int-const";

export default function AdministracionScreen() {

    const [cargandoPage, setCargandoPage] = useState(true);
    const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(false);
    const [infoUsuario, setInfoUsuario] = useState(null);

    useEffect(() => {
        iniciar();
    }, []);

    const iniciar = async () => {
        try {
            const infoUsuario = await obtenerInfoUsuario();
            // console.log('infoUsuario', infoUsuario);
            if (infoUsuario.error === false) {
                setInfoUsuario(infoUsuario.body);
            }
            setCargandoPage(false);
            setTieneAccesoAlModulo(true);
        } catch (err) {
            setTieneAccesoAlModulo(false);
            console.log('iniciar err');
            console.log(err);
        }
    }

    const render = () => {
        try {
            // if (cargandoPage === true) {
            //     return cargandoCard();
            // }
            // if (tieneAccesoAlModulo === false) {
            //     return sinAccesoCard();
            // }
            return (
                <div className="flex flex-wrap">
                    {infoUsuario !== null && infoUsuario.idRolUsuario === INT_TIPO_USUARIO.REFUGIO ? (
                        MODULOS_ADMINISTRACION
                            .filter((data) => data.tipo === INT_TIPO_USUARIO.REFUGIO)
                            .map((data) => Modulo(data))
                    ) : null}
                    {infoUsuario !== null && infoUsuario.idRolUsuario === INT_TIPO_USUARIO.PUBLICIDAD ? (
                        MODULOS_ADMINISTRACION
                            .filter((data) => data.tipo === INT_TIPO_USUARIO.PUBLICIDAD)
                            .map((data) => Modulo(data))
                    ) : null}
                    {infoUsuario !== null && infoUsuario.idRolUsuario === INT_TIPO_USUARIO.REFUGIO_Y_PUBLICIDAD ? (
                        MODULOS_ADMINISTRACION
                            .map((data) => Modulo(data))
                    ) : null}
                    {/* {MODULOS_ADMINISTRACION.map((data) => Modulo(data))} */}
                </div>
            );
        } catch (err) {
            console.log('render err dashboard');
            console.log(err);
            return (
                <div className="m-8" >
                    <label>{JSON.stringify(err)}</label>
                </div>
            );
        }
    }


    return render();
};
